import axios from '@_system/axios/axios.js'
export default {
	path: '/paymentapplication',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updatefromlist(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatefromlist/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	
	
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getPaymentAccount(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getPaymentAccount', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getInvoiceInfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getInvoiceInfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	getReceiptInfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getReceiptInfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	reflashDownloadNo(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reflashDownloadNo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	sendReceipt(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendReceipt', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	grabbipurchase(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/grabbipurchase', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	status(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/status', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	getsupplierlicense(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getsupplierlicense', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	uploadinvoice(id,data={}){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/uploadinvoice/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	// uploadreceipt(id,data={}){
	// 	return new Promise((resolve, reject) => {
	// 		axios.post(this.path + '/uploadreceipt/'+id, data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },	
		
	
	ocrinvoice (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/ocrinvoice', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	sendjindie (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/sendjindie', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/paymentapplication.paymentapplication', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
